import styles from "./PolicySectionHeading.module.css";

interface PolicySectionHeadingProps {
  heading: string;
}

export default function PolicySectionHeading({
  heading,
}: PolicySectionHeadingProps): JSX.Element {
  return (
    <div className={styles.container}>
      <div className={styles.heading}>{heading}</div>
    </div>
  );
}
